<div class="divisa-col-sm-12 my-auto only mt-2" *ngIf="sucursal">
  <div class="card-footer divisa-row sucursal-promo-card">
    <img class="divisa-col-2 divisa-col-md-2 my-auto" style="max-width: 40px; max-height: 40px;" src="./assets/img/circle-icon.svg" alt="">
    <div class="divisa-col-9 divisa-col-md-4 my-auto">
      <h6 class="mb-0 text-center divisa-col-12">
        {{ getBranchName() }}</h6>
    </div>
    <p class="divisa-col-12 divisa-col-md-5 pl-3 my-md-auto my-mb-0 mt-2">
      {{ getBranchStreet() }}
    </p>
  </div>
  <div class="card border-success pb-4">
    <div class="">
      <div #map style="width:100%; height:198px"></div>
    </div>
  </div>
  <div class="overflow-html" [innerHTML]="html | safeHtml"></div>
</div>
